import { findAttachmentRule } from './attachmentRules.ts';

export interface ClipboardFiles {
    types: readonly string[];
    files: ArrayLike<File>;
}

const FALLBACK_NAME = 'attachment';

// Office apps put an image rendering next to the copied text; only a file-only paste is an attachment.
export function filesFromClipboard({ types, files }: ClipboardFiles): File[] {
    if (types.includes('text/plain')) return [];
    return Array.from(files);
}

export function defaultAttachmentName(mimeType: string): string {
    const extension = findAttachmentRule(mimeType)?.extensions[0];
    return extension ? `${FALLBACK_NAME}.${extension}` : FALLBACK_NAME;
}

// Untyped blobs would upload as octet-stream and fail the backend's declared-type check.
export function withMimeType(file: Blob, name: string, mimeType: string): Blob {
    if (file.type === mimeType) return file;
    return new File([file], name, { type: mimeType });
}
